// extracted by mini-css-extract-plugin
export default {"headerMain":"Header_headerMain__XTaEy","headerContent":"Header_headerContent__RYsra","infoButton":"Header_infoButton__YJjKi","infoCard":"Header_infoCard__oYHyF"};